import { forwardRef } from "react";

import type { LucideProps } from "lucide-react";

/**
 * Crew members settings nav icon.
 * Uses currentColor so parent text-* classes control active, hover, and gated states.
 */
const CrewMembersIcon = forwardRef<SVGSVGElement, LucideProps>(({ className, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M12.6667 12.2181V7.09761C12.6666 6.13528 11.981 5.30946 11.0352 5.13211L9.10547 4.77014C8.37487 4.63318 7.62513 4.63319 6.89453 4.77014L4.96484 5.13211C4.01898 5.30946 3.33345 6.13528 3.33333 7.09761V12.2181C3.33333 12.5862 3.03486 12.8847 2.66667 12.8847C2.29848 12.8847 2 12.5862 2 12.2181V7.09761C2.00012 5.49376 3.14239 4.11727 4.71875 3.82157L6.64844 3.45959C7.54162 3.29212 8.45838 3.29212 9.35156 3.45959L11.2813 3.82157C12.8576 4.11727 13.9999 5.49376 14 7.09761V12.2181C14 12.5862 13.7015 12.8847 13.3333 12.8847C12.9651 12.8847 12.6667 12.5862 12.6667 12.2181Z"
      fill="currentColor"
    />
    <path
      d="M3.11048 11.7748C6.34355 11.187 9.65605 11.187 12.8891 11.7748L15.4523 12.241C15.8145 12.3068 16.0546 12.6535 15.9887 13.0157C15.9229 13.378 15.5762 13.618 15.214 13.5522L12.6508 13.0867C9.57537 12.5275 6.42423 12.5275 3.34876 13.0867L0.785605 13.5522C0.423375 13.618 0.0767261 13.378 0.0108657 13.0157C-0.0549623 12.6535 0.185092 12.3068 0.547324 12.241L3.11048 11.7748Z"
      fill="currentColor"
    />
    <path
      d="M9.99984 7.81968C9.99984 7.65019 9.87265 7.5075 9.70426 7.4883L8.67757 7.37176C8.22738 7.32061 7.77229 7.32061 7.3221 7.37176L6.29541 7.4883C6.12702 7.5075 5.99984 7.65019 5.99984 7.81968V8.83726C6 9.03613 6.17329 9.19045 6.37093 9.16799L7.17171 9.07684C7.72194 9.01432 8.27773 9.01432 8.82796 9.07684L9.62874 9.16799C9.82638 9.19045 9.99967 9.03613 9.99984 8.83726V7.81968ZM11.3332 8.83726C11.333 9.83213 10.4669 10.6052 9.47835 10.4929L8.67757 10.4017C8.22738 10.3506 7.77229 10.3506 7.3221 10.4017L6.52132 10.4929C5.53277 10.6052 4.66667 9.83213 4.6665 8.83726V7.81968C4.6665 6.97202 5.30278 6.25914 6.14502 6.16343L7.17171 6.04689C7.72194 5.98437 8.27773 5.98437 8.82796 6.04689L9.85465 6.16343C10.6969 6.25914 11.3332 6.97202 11.3332 7.81968V8.83726Z"
      fill="currentColor"
    />
    <path
      d="M9.33317 3.66602C9.33317 4.2183 8.88546 4.66602 8.33317 4.66602H7.6665C7.11422 4.66602 6.6665 4.2183 6.6665 3.66602C6.6665 3.11373 7.11422 2.66602 7.6665 2.66602H8.33317C8.88546 2.66602 9.33317 3.11373 9.33317 3.66602Z"
      fill="currentColor"
    />
  </svg>
));

CrewMembersIcon.displayName = "CrewMembersIcon";

export default CrewMembersIcon;
export { CrewMembersIcon };
